import { ONLINE_STATUS_MAP } from '../../../../constants';
import OnlineStatus from '../../../OnlineStatus/OnlineStatus';

function OnlineStatusCellRenderer({ value }) {
  return <OnlineStatus variant={ONLINE_STATUS_MAP[value]?.variant} size={10} />;
}

export default OnlineStatusCellRenderer;
